// extracted by mini-css-extract-plugin
export var editButton = "_mz-0";